import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router'
import { Observable, Subject } from 'rxjs';
import * as moment from 'moment-timezone';


@Injectable({
    providedIn: 'root'
})
export class ComplaintDetailService {
    baseUrl = environment.baseUrl;
    complaintDetail: any;
    messages:any[];
    routeParams: any;
    timelineData: any;
    incidentData:any;
    commentData:any;
    user:any;
    private subject = new Subject<any>();


    constructor(private _httpClient: HttpClient) { 
        this.user = localStorage.getItem('user_id')
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params.id
        return new Promise((resolve, reject) => {

            Promise.all([
                this.getDetail(),
                this.getTimeline(),
                this.getComments()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getDetail(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.baseUrl + 'incident/' + this.routeParams)
                .subscribe((response: any) => {
                    this.complaintDetail = response.data
                    this.messages = response.data.incident_comments
                    console.log('messagessssssssssssssssssssssss', this.messages)
                   
                    resolve(response);
                }, reject);
        });
    }

    getTimeline(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.baseUrl + 'incidents/timeline/' + this.routeParams)
                .subscribe((response: any) => {
                    this.timelineData = response.timeline_data
                    this.incidentData = response.incident_data
                    console.log('timeline', this.timelineData)
                    resolve(response);
                }, reject);
        });
    }

    getComments(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.baseUrl + 'incident/comments/' + this.routeParams)
                .subscribe((response: any) => {
                    this.commentData = response.data.incident_comments
                    console.log('commentData', response)
                   
                    resolve(response);
                    this.getTimeline()
                }, reject);
        });
    }

    // 
    comment(data): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.baseUrl + 'user/incident/comment', data)
                .subscribe((response: any) => {
                    // date
                    // 
                    const date = new Date();
                    const victimName = 'victim'                
                    this.subject.next({ comment:data.comment,date:date,commented_by:victimName,user_id:{_id:this.user} });
                    resolve(response);
                }, reject);
        });
    }

    getMessage(): Observable<any> {
        console.log('observable',this.subject.asObservable())
        return this.subject.asObservable();
    }

}
